import React, {cloneElement, Component} from 'react';
import axios from 'axios';
import {Navigate} from 'react-router-dom';
import withRouter from "../withRouter";
import $ from "jquery";
import Select from 'react-select';
import Cookies from 'js-cookie';
import { IoMdKey } from "react-icons/io";
import { MdLogout } from "react-icons/md";
import twtlogo from "../../assets/images/twtlogonobg.png"
import enmovilLogo from "../../assets/images/enmovillogo.jpg"
import * as BsIcons from "react-icons/bs";
import * as AiIcons from "react-icons/ai";
// import { IoNotificationsOutline } from "react-icons/io5";
// import { IoNotificationsOutline } from "react-icons/md";
import { IoNotificationsOutline } from "react-icons/io5";
import { IoIosLogOut } from "react-icons/io";
import { TfiUser } from "react-icons/tfi";

class Navbar extends Component {
    constructor(props){
      super(props);
      this.state = {
        dispatchDataTypecheck : 0,
        dispatch_data_type : {"label":"Select Data Type","value":""},
        mouseEnter:'show-n',
        notifyMouseEnter : "show-n",
        emailCheck: sessionStorage.getItem("twtemail") || localStorage.getItem("twtemail") === "optipredadmin@enmovil.in"    
      }
    }
    
    componentDidMount()
    {
        if(localStorage.getItem("module_type") == 1 && localStorage.getItem("both_data_types_enabled_for_dispatch") == 1)
        {
            var currentUrl = window.location.href;
            if(localStorage.getItem("data_type") == 1)
            {
                var dataType = "Inbound"
            }
            else
            {
                var dataType = "Outbound"
            }
            if(currentUrl.includes("viewdispatchplandetails") == true)
            {
                this.setState({
                    dispatchDataTypecheck : 0
                });
            }
            else
            {
                this.setState({
                    dispatchDataTypecheck : 1,
                    dispatch_data_type : {"label":dataType,"value":localStorage.getItem("data_type")}
                });
            }
        }
    }
    logout = async(e) => {
        // console.log('hit')
            e.preventDefault();
          
            await localStorage.removeItem('token');
            await localStorage.removeItem('email');
            await localStorage.removeItem('user_type');
            await localStorage.removeItem('role');
            await localStorage.removeItem('user_code');
            await localStorage.clear();
            sessionStorage.setItem('ref',null);
            //localStorage.setItem('menuText',[]);
            await delete axios.defaults.headers.common['Authorization'];
            this.setState({
                redirectToReferrer:''
            });
            console.log("logout successfully",localStorage.getItem('token'));
            
            window.location.reload();
            // await relaodpage(loginType);
        
           
        }
    changeDispatchDataType = (event) => {
        if(event.value !=undefined && event.value !="")
        {
            localStorage.setItem("data_type",event.value);
            var url_type = window.location.href
            console.log(url_type,"url_type")
            var path_type = url_type.split('?')
            console.log(path_type,"path_type")
            if(event.value == 1)
            {
                var pathend = "inbound";
            }
            else
            {
                var pathend = "outbound";
            }
            // var path = path_type[0]+"?"+pathend;
            var path = "loadprocessrun?"+pathend;
            window.location.href = path;
        }
    }
    dispathTypeOptns = () =>  {
        var optns = [];
        // optns.push({"label" : "Select Data Type","value" : ""});
        optns.push({"label" : "Inbound","value" : 1});
        optns.push({"label" : "Outbound","value" : 2});
        console.log(optns,"optns")
        return optns;
    }
    handleMouseEnter= async()=>{
        this.setState({mouseEnter:'show-m'})
    }
    handleMouseLeave= async()=>{
        this.setState({mouseEnter:'show-n'})
    }

    handleNotifyEnter= async()=>{
        this.setState({notifyMouseEnter:'show-m'})
    }

    handleNotifyLeave= async()=>{
        this.setState({notifyMouseEnter:'show-n'})
    }

    render(){
        if(Cookies.get("token") === "" || Cookies.get("token") === undefined || Cookies.get("token") === null)
		{
			return <Navigate  to={"/login"} push={true} />
		}
        if(localStorage.getItem("token") === "" || localStorage.getItem("token") === undefined || localStorage.getItem("token") === null)
		{
			return <Navigate  to={"/login"} push={true} />
		}
        var moduleTitle = "";
        if(localStorage.getItem("module_type") == 1)
        {
            moduleTitle = "Dispatch Planning";
        }
        if(localStorage.getItem("module_type") == 2)
        {
            moduleTitle = "Stacking";
        }
        if(localStorage.getItem("module_type") == 3)
        {
            moduleTitle = "Production Planning";
        }
        if(localStorage.getItem("module_type") == 4)
        {
            moduleTitle = "Forecasting";
        }
        if(localStorage.getItem("module_type") == 5)
        {
            moduleTitle = "Resource Scheduling";
        }
        return (
            <div className="nav_menu">
                <div className="nav toggle" style={{position:"relative", display: "block", marginTop: "5px", paddingY:50}}>
                    <a href={"/"} style={{fontSize:"20px"}}>
                        <img src={enmovilLogo} alt="enmovil" style={{height:"35px"}} />
                        {/* <span className="module-header-text fhttle">{moduleTitle}</span> */}
                    </a>
                    
                </div>
                <div className="col-sm-4">
                </div>
                {this.state.dispatchDataTypecheck == 1 ?
                <div className="col-sm-3">
                    <Select
                        placeholder={"Select"}
                        onChange={this.changeDispatchDataType}
                        name="location"
                        id="selectoptns"
                        className="mt-5p selectoptns"
                        value={this.state.dispatch_data_type}
                        options={this.dispathTypeOptns()} 
                    />
                </div> 
                :""}
                <nav className="nav navbar-nav">
                    <ul className="navbar-right">
                        <li style={{marginRight : 20}}>
                             {/* <a href={"/"} style={{fontSize:"20px"}} title='TWT Logo'> */}
                                <img src={twtlogo} alt="twtlogo" style={{height:"50px", width : "170x"}} />
                                {/* <span className="module-header-text fhttle">{moduleTitle}</span> */}
                            {/* </a> */}
                        </li>
                        <div onMouseEnter={this.handleMouseEnter}  
                        onMouseLeave={this.handleMouseLeave}
                         style={{marginRight : "20px"}}>
                        <li 
                            style={{ display : "flex", alignItems :"center", marginBottom : -14,}}>
                            <p style={{fontSize : "25px",cursor : "pointer"}}>
                                <TfiUser  style={{color : "#BB396E"}}/>
                            </p>
                        </li>
                        <li
                            style={{
                                textAlign: "left",
                                padding: "20px",
                                marginRight: 40,
                                marginTop: 40,
                                borderRadius: "10px",
                                backgroundColor: "#f9f9f9",
                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                                width: "250px",
                            }}
                            className={`popup ${this.state.mouseEnter}`}
                            >
                            <ol style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                                <li style={{ marginBottom: "15px", color: "#5A738E" }}>
                                <p style={{ margin: "5px 0", fontWeight: 500, fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                                    <AiIcons.AiOutlineMail style={{ fontSize: "16px", marginRight: "8px", color: "#333", fontWeight: "bold" }} />
                                    {localStorage.getItem("email")}
                                </p>
                                <p style={{ margin: "5px 0", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                                    <AiIcons.AiOutlineIdcard style={{ fontSize: "16px", marginRight: "8px", color: "#333" }} />
                                    {localStorage.getItem("username")}
                                </p>
                                </li>
                                {localStorage.getItem("email") === "thewholetruth@enmovil.in" && 
                                    <li style={{ marginBottom: "12px", display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                                    <a href="/user-actions" style={{ textDecoration: "none", color: "#333", display: "flex", alignItems: "center" }}>
                                        <AiIcons.AiOutlineAudit style={{ fontSize: "18px", marginRight: "6px", color: "#333" }} />
                                        Actions
                                    </a>
                                    </li>
                                }

                                <li style={{ marginBottom: "12px", display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                                <a href="/reset" style={{ textDecoration: "none", color: "#333", display: "flex", alignItems: "center" }}>
                                    <IoMdKey style={{ fontSize: "18px", marginRight: "6px" }} />
                                    Change Password
                                </a>
                                </li>
                                {
                                    (!this.state.emailCheck) &&
                                    <>
                                        <li style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                                        <a href="/logout" style={{ textDecoration: "none", color: "#e74c3c", display: "flex", alignItems: "center" }}>
                                            <MdLogout style={{ fontSize: "18px", marginRight: "6px" }} />
                                            Logout
                                        </a>
                                        </li>
                                    </>
                                    
                                }
                            </ol>
                        </li>

                        </div>
                        <div onMouseEnter={this.handleNotifyEnter}  onMouseLeave={this.handleNotifyLeave}>
                          <li style={{marginRight : 20}}>
                            <span style={{color : "#BB396E", fontSize : 25, cursor: "pointer"}}  title="Notifications">  
                                <IoNotificationsOutline />
                            </span>
                          </li>
                            <li>
                                <div  style={{textAlign:"center",alignItems:'center',paddingRight:'20px', paddingBottom: "10px", marginRight:70, marginTop: 50}} className={'popup '+ this.state.notifyMouseEnter} >
                                    <ol style={{display:'d-flex',flexDirection:'column'}}>
                                       
                                        <li className='mb-2 mt-2' style={{display: "flex", alignItems: "center"}}>
                                            No notifications found!
                                            {/* <a href="/reset">
                                            <IoMdKey  style={{fontSize: "20px", marginRight: "5px"}}
                                            />
                                                &nbsp;Change Password</a> */}
                                        </li>
                                        {/* <li className='mr-3 mb-2' style={{display: "flex", alignItems: "center"}}>
                                            <a href="/logout">
                                            <MdLogout  style={{fontSize: "20px", marginRight: "5px"}}/>
                                            Logout&nbsp;</a></li> */}
                                    </ol>
                                </div>
                            </li> 
                        </div> 
                        {
                            (!this.state.emailCheck) && 
                            <>
                                <li>
                                    <a href="/logout"  style={{color : "red", cursor : "pointer"}} title='Logout'>
                                    <span style={{color : "#BB396E", fontSize : 25, cursor: "pointer"}}  title="Logout">  
                                        <IoIosLogOut />
                                    </span>
                                    </a>
                                </li>
                            </>
                        }
                        
                      
                        
                    </ul>
                </nav>
            </div>
        );
    }
}

export default withRouter(Navbar) ;